import { ElLoading } from 'element-plus'

// 保存 Loading 实例和计数器
let loadingInstance = null
let loadCount = 0

export const showLoading = () => {
  if (loadCount === 0) {
    loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
  }
  loadCount++
}

export const hideLoading = () => {
  if (loadCount <= 0) return
  loadCount--

  if (loadCount === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

// 可选：重置方法（强制关闭）
export const resetLoading = () => {
  loadCount = 0
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}